import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Carousel, CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide } from "@cinch-labs/design-system";
import { formatNumber, useViewport } from "@cinch-labs/shared-util";
import ReviewCard from "../trustpilot-review-card/trustpilot-review-card";
import Wrapper from "../wrapper/wrapper";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import styles from "./trustpilot-reviews.module.css";
var carouselName = "trustpilot-carousel";
var navAriaLabels = {
    previous: "Go to previous slide",
    next: "Go to next slide"
};
var trustpilotUrl = "https://uk.trustpilot.com/review/cinch.co.uk";
var ReviewSection = function(param) {
    var title = param.title, reviews = param.reviews, numberOfReviews = param.numberOfReviews, starRatingLabel = param.starRatingLabel;
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isDesktop = vw >= 1024;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "data-testid": "trustpilotReviews",
        className: {
            container: styles.root
        },
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: styles.reviewsTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                children: isDesktop ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.trustPilotReviewsDesktopWrapper,
                            children: reviews.map(function(review) {
                                return /*#__PURE__*/ _jsx(ReviewCard, _object_spread({}, review), review.title);
                            })
                        }),
                        /*#__PURE__*/ _jsxs("a", {
                            href: trustpilotUrl,
                            className: styles.trustPilotLink,
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ _jsxs("p", {
                                    className: styles["trustpilotLinkText"],
                                    children: [
                                        "Rated ",
                                        starRatingLabel,
                                        " | ",
                                        formatNumber(numberOfReviews),
                                        " ",
                                        "reviews"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(TrustpilotLogo, {
                                    className: styles.logo
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Carousel, {
                            customClassNames: {
                                wrapper: styles.carouselWrapper
                            },
                            name: carouselName,
                            children: reviews.map(function(review, idx) {
                                return /*#__PURE__*/ _jsx(CarouselSlide, {
                                    children: /*#__PURE__*/ _jsx(ReviewCard, _object_spread({}, review), review.title)
                                }, idx);
                            })
                        }),
                        /*#__PURE__*/ _jsxs(CarouselControls, {
                            customClassNames: styles.controlsWrapper,
                            children: [
                                /*#__PURE__*/ _jsx(CarouselPagination, {
                                    name: carouselName,
                                    customClassNames: styles.carouselPagination
                                }),
                                /*#__PURE__*/ _jsx(CarouselNavigation, {
                                    name: carouselName,
                                    ariaLabels: navAriaLabels,
                                    customClassNames: {
                                        prevButton: styles.carouselPrevButton,
                                        nextButton: styles.carouselNextButton
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default ReviewSection;
